import api from './apiService';

const chatEndpoint = '/chat';

export function saveChat(chat) {
  return api.post('/chat/', chat);
}

export function getHistory(page) {
  return api.get(`${chatEndpoint}/history?offset=${page}`);
}

export function getValidators() {
  return api.get(`${chatEndpoint}/validators`);
}
